import { registerApplication, start } from 'single-spa'
import { constructApplications, constructRoutes, constructLayoutEngine } from 'single-spa-layout'
import microfrontendLayout from './microfrontend-layout.html'
import { injectGlobal } from '@emotion/css'
import { boostTerminalLikeHover } from './terminalLikeFont/index.js'

import '@fontsource/inter'

injectGlobal`
  @font-face {
    font-family: 'CreatoDisplay';
    src: url('/public/creato_display/CreatoDisplay-ExtraBold.woff2') format('woff2');
    font-weight: 700; 
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    font-display: swap;
  }

  @font-face {
    font-family: 'CreatoDisplay';
    src: url('/public/creato_display/CreatoDisplay-Bold.woff2') format('woff2');
    font-weight: 600; 
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'CreatoDisplay';
    src: url('/public/creato_display/CreatoDisplay-Medium.woff2') format('woff2');
    font-weight: 500; 
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'CreatoDisplay';
    src: url('/public/creato_display/CreatoDisplay-Regular.woff2') format('woff2');
    font-weight: 400; 
    font-style: normal;
    font-display: swap;
  } 

  @font-face {
    font-family: 'CreatoDisplay';
    src: url('/public/creato_display/CreatoDisplay-Light.woff2') format('woff2');
    font-weight: 300; 
    font-style: normal;
    font-display: swap;
  }   

  @font-face {
    font-family: 'Goldman';
    src: url('/public/goldman_display/Goldman-Regular.woff2') format('woff2');
    font-weight: 400; 
    font-style: normal;
    font-display: swap;
  } 

  @font-face {
    font-family: 'Goldman';
    src: url('/public/goldman_display/Goldman-Bold.woff2') format('woff2');
    font-weight: 600; 
    font-style: normal;
    font-display: swap;
  }     
`

const routes = constructRoutes(microfrontendLayout)
const applications = constructApplications({
    routes,
    loadApp({ name }) {
        return System.import(name)
    },
})
const layoutEngine = constructLayoutEngine({ routes, applications })

applications.forEach(registerApplication)
layoutEngine.activate()
start()

setTimeout(() => {
    boostTerminalLikeHover()
}, 2000)

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/service-worker.js', { scope: '/community/' })
            .then(() => console.log('✅ Service Worker registered'))
            .catch((err) => console.error('Service Worker registration failed:', err))
    })
}

injectGlobal`
  html {
    overflow-x: hidden;
  }
  body {
    margin: 0;
    font-family: "CreatoDisplay", "Inter";
    -webkit-font-smoothing: antialiased;
    overflow-x: hidden;
  }

  button {
    margin: 0;
    font-family: "CreatoDisplay", "Inter" !important;
  }

  h1 {
    font-family: "CreatoDisplay", "Inter";
    font-weight: 500;
  }

  p {
    margin: 0 !important;
  }

  .pin-spacer {
    background-color: black !important;
  }

  #home-placeholder {
    width: 100%;
    background: #000;
    height: 2000px;
  }

  .flare_button:after {
        bottom: 0;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        content: '';
        pointer-events: none;
    }

    .button--stroke:hover .button__label {
        transition: color 0.15s ease-in-out;
    }

    .button__flair {
        bottom: 0;
        left: 0;
        pointer-events: none;
        position: absolute;
        right: 0;
        top: 0;
    }

    .button__flair:before {
        aspect-ratio: 1/1;
        border-radius: 50%;
        content: "";
        display: block;
        left: 0;
        pointer-events: none;
        position: absolute;
        top: 0;
        transform: translate(-50%, -50%);
        width: 200%;
    }

    .button__label {
        position: relative;
        text-align: center;
        transition: color 50ms ease-in-out;
    }

    .button--stroke .button__flair {
        transform: scale(0);
        transform-origin: 0 0;
        will-change: transform;
    }    

    .terminal-like-hover .word {
      white-space: nowrap;
    }

    .terminal-like-hover .char {
      position: relative;
      --opa: 0;
    }

    .terminal-like-hover {
      font-kerning: none;
      position: relative;
      white-space: nowrap;
    }    

    .terminal-like-hover .char::after {
      content: '';
      width: 1ch;
      top: 0;
      left: 0;
      position: absolute;
      opacity: var(--opa);
    }

    .terminal-like-hover .char::after {
      background: #a59dff;
      height: 100%;
    }    
`
